import { Component, Input } from '@angular/core';
import { filter, switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { DashboardApi } from '../../../api/dashboard/dashboard.api';
import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { LandingPageFeedsModel } from 'app/LandingPage/models/landingpage-feeds.model';
import { XMLParser } from 'fast-xml-parser';

@Component({
    selector: 'agpr-landing-page-feed-reader',
    templateUrl: './landing-page-feed-reader.component.html',
    styleUrls: ['./landing-page-feed-reader.component.scss'],
    standalone: false
})
export class LandingPageFeedReaderComponent {

    @Input() title: string = '';
    @Input() description: string;
    @Input() viewAll: string;
    @Input() id: string;
    @Input() showAuthor: boolean = false;
    @Input() isPrNews: boolean = false;
    @Input() isAgilityNews: boolean = false;
    @Input() isPrResources: boolean = false;

    @Input() set feed(feed: string) {
        if (feed) {
            this.fetchDashboardFeed(feed);
        }
    }

    readonly buttonTypesEnum = ButtonTypesEnum;

    feeds: LandingPageFeedsModel[]= [];
    dateFormat: string = 'MMM d, y, HH:mm';
    agilityDateFormat: string = 'MMM y';

    parserOptions = {
        ignoreAttributes : true
    };
    parser = new XMLParser(this.parserOptions);

    subscriptions: Subscription[] = [];

    constructor(
        public dashboardApi: DashboardApi,
        public currentUserStateService: CurrentUserStateService
    ) {
        this.subscriptions.push(
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(prefs => {
                this.dateFormat = prefs.getDateFormatString(false, false, false);
            })
        );
    }


    fetchDashboardFeed(feed: string) {
        this.dashboardApi.getFeeds(feed)
            .pipe(
                switchMap(async xml => this.parseXmlToJson(xml))
            )
            .subscribe(
                response => {
                    this.feeds = response.slice(0, 3).map(feeds => new LandingPageFeedsModel(feeds));
                }
            );
    }

    async parseXmlToJson(xml): Promise<any[]>  {
        return this.parser.parse(xml)?.rss?.channel?.item || [];
    }
}
